import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Icon from '@material-ui/core/Icon';
// core components
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
import Card from "@app/components/Card/Card";
import CardBody from "@app/components/Card/CardBody";
// IMG
import promoCardStyle from "@app/assets/jss/material-kit-pro-react/components/cards/promoCardStyle";

const PromoCard = props => {
    const { classes } = props;

    return (
            <Card raised>
                <GridContainer>
                    <GridItem xs={3} className={classes.iconTable}>
                        <Icon className={classes.iconRoot}>
                            <img className={classes.imageIcon} src={props.icon}/>
                        </Icon>
                    </GridItem>
                    <GridItem xs={9}>
                        <CardBody>
                            <h3 className={classes.cardTitle}>
                                {props.title}
                            </h3>
                            <p className={classes.description}>
                                <b>{props.description}</b>
                            </p>
                            {props.links && props.links.map((link) =>
                                <span><a key={link.text} href={link.to}>{link.text}</a>&nbsp;&nbsp;&nbsp;</span>
                            )}
                        </CardBody>
                    </GridItem>
                </GridContainer>
            </Card>
        );
    }
    
export default withStyles(promoCardStyle)(PromoCard);